import Splide from '@splidejs/splide-4';

import { _isOnScreen, _once } from '../../utils';
import initTabs from '../tabs/tabs';

const commonSplideOptions = {
  type: 'slide',
  rewind: true,
  pagination: false,
  arrows: true,
  perPage: 3,
  gap: 16,
  breakpoints: {
    1024: {
      perPage: 2,
    },
    640: {
      perPage: 1,
    },
  },
};

initTabs('.js--reviews-tabs');

_isOnScreen(
  '.splide-reviews',
  _once(() => {
    const reviewsSliders = [
      {
        selector: '.splide-reviews',
        label: 'Site reviews',
      },
      {
        selector: '.splide-sitejabber',
        label: 'SiteJabber reviews',
      },
      {
        selector: '.splide-reviewsio',
        label: 'ReviewsIo reviews',
      },
    ];

    reviewsSliders.forEach(slider => {
      if (document.querySelector(slider.selector)) {
        new Splide(slider.selector, {
          label: slider.label,
          ...commonSplideOptions,
        }).mount();
      }
    });
  }),
);
